var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Icon, Stack, useTheme } from "@fluentui/react";
import React, { useId } from "react";
import { getDisplayFlex } from "../EvolvedSettingsDialog.styles";
import EvolvedSettingsAction from "./EvolvedSettingsAction";
import { getActionIconStackStyle, getActionIconStyle, } from "./EvolvedSettingsAction.styles";
// An object that toggles its icon and aria label description based on the checked value provided.
export const EvolvedSettingsToggleIconButton = React.memo((_a) => {
    var { title, checked, checkedActionIconName, checkedActionIconLabel, uncheckedActionIconName, uncheckedActionIconLabel, callback, isMultiLine } = _a, rest = __rest(_a, ["title", "checked", "checkedActionIconName", "checkedActionIconLabel", "uncheckedActionIconName", "uncheckedActionIconLabel", "callback", "isMultiLine"]);
    const theme = useTheme();
    const id = "action-setting-toggle-button-" + useId();
    return React.createElement(EvolvedSettingsAction, Object.assign({ id: id, title: title, onClick: callback, actionNode: React.createElement(Stack.Item, { "aria-label": title + " " + (checked ? checkedActionIconLabel : uncheckedActionIconLabel), styles: getDisplayFlex(getActionIconStackStyle(true)) },
            React.createElement(Icon, { iconName: checked ? checkedActionIconName : uncheckedActionIconName, styles: getDisplayFlex(getActionIconStyle(theme)) })) }, rest));
});
export default EvolvedSettingsToggleIconButton;
